<template>
  <div class="ugc-wrap">
    <div class="ctn">
      <h1
        class="logo"
        title="元气壁纸"
      />
      <span
        class="slogan"
        title="壁纸创作中心，让大家看到你的才华!"
      />
      <span
        class="link-dynamic"
        to="/creation/video"
        @click="handleUpload('dynamic')"
      >
        <i class="icon-video" />
        <span>上传动态壁纸</span>
      </span>
      <span
        class="link-static"
        to="/creation/photo"
        @click="handleUpload('static')"
      >
        <i class="icon-pic" />
        <span>上传静态壁纸</span>
      </span>
      <router-link
        v-if="userInfoFresh.user_type !== undefined && !userInfoFresh.user_type"
        class="link-contract"
        to="/contract/author"
      >
        <strong>让你的才华收益最大化！</strong>
        <span>认证成为元气UP，上传原创动态壁纸赚取收益吧~</span>
        <div class="btn-contract">
          认证元气UP
        </div>
      </router-link>
      <div class="sence" />
    </div>
    <div class="wallhaven-wrap">
      <div class="list">
        <div
          v-for="(row, rowIndex) in wallhaven.row"
          ref="wallhavenRow"
          :key="row"
          class="row"
        >
          <div
            v-for="(item, index) in wallhaven.count"
            :key="index"
            class="item"
            :class="`item-${index}`"
          >
            <img
              :src="`/wallhaven/wallhaven-${getWallhavenItem(rowIndex, index)}.png`"
              alt=""
            >
          </div>
          <div
            v-for="(item, index) in wallhaven.addtion"
            :key="`addtion${index}`"
            class="item"
            :class="`addtion-${index}`"
          >
            <img
              :src="`/wallhaven/wallhaven-${getWallhavenItem(rowIndex, index)}.png`"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
    <SelectUploadPlatform
      v-if="selectUploadModeVisible"
      :type="selectedWallpaperType"
      @hide="handleHideUpload"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { fetchUserInfo } from '@/api/user'
import SelectUploadPlatform from '@/components/Upload/SelectUploadPlatform'

export default {
  name: 'Ugc',
  components: {
    SelectUploadPlatform,
  },
  data() {
    return {
      userInfoFresh: {},
      selectUploadModeVisible: false,
      selectedWallpaperType: '',
      wallhaven: {
        gap: 5,
        itemWidth: 400,
        itemHeight: 225,
        row: 0,
        count: 10,
        addtion: 0, // 无缝滚动需添加的数量
        duration: 7 * 10,
        wallhavenPicCount: 61,
        list: [],
      },
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
    }),
  },
  watch: {
    common() {
      this.fetchUserInfo()
    },
  },
  mounted() {
    this.fetchUserInfo()

    window.addEventListener('resize', () => {
      this.checkRowLength()
    })
    this.checkRowLength()
    setTimeout(() => {
      this.initMarquee()
    }, 0)
  },
  methods: {
    handleUpload(type) {
      this.selectedWallpaperType = type
      this.selectUploadModeVisible = true
    },
    handleHideUpload() {
      this.selectedWallpaperType = ''
      this.selectUploadModeVisible = false
    },
    checkRowLength() {
      const { itemWidth, itemHeight, gap, count } = this.wallhaven
      const width = window.innerWidth
      const height = window.innerHeight
      this.wallhaven.row = Math.ceil(height / itemHeight)
      this.wallhaven.addtion = Math.ceil(width / (itemWidth + gap))

      const allPicList = []
      let retryCount = 0
      const maxRetry = 5

      for (let row = 0, rowlen = this.wallhaven.row; row < rowlen; row++) {
        const list = []
        for (let item = 0, itemlen = count; item < itemlen; item++) {
          let itemData
          while (retryCount < maxRetry && !itemData) {
            itemData = this.getRandomIntInclusive(1, this.wallhaven.wallhavenPicCount)
            if (allPicList.find((n) => {
              return itemData === n
            }) !== undefined) {
              itemData = null
            }
            retryCount++
          }

          if (itemData === null) {
            itemData = this.getRandomIntInclusive(1, this.wallhaven.wallhavenPicCount)
          }

          list[item] = itemData
          allPicList.push(itemData)
          retryCount = 0
        }
        this.wallhaven.list[row] = list
      }
    },
    getWallhavenItem(row, item) {
      if (this.wallhaven.list[row] && this.wallhaven.list[row][item]) {
        return this.wallhaven.list[row][item]
      }

      return 1
    },
    getRandomIntInclusive(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min // 含最大值，含最小值
    },
    initMarquee() {
      this.$refs.wallhavenRow.forEach(($row, index) => {
        const { itemWidth, count, gap, duration, addtion } = this.wallhaven
        const w = (itemWidth + gap) * (count + addtion)
        const left = (itemWidth + gap) * count
        let rule = this.getCssRule(`marquee${index % 5}`)

        if (!rule) {
          const style = document.createElement('style')
          style.innerHTML = `@keyframes marquee${index % 5} {}`
          document.body.appendChild(style)
          rule = this.getCssRule(`marquee${index % 5}`)
        }

        const widthStyle = `width:${w}px;`
        const animationStyle = `animation: marquee${index % 5} ${(count * duration)}s linear infinite;`

        if (index % 2) {
          rule.appendRule(`0% { transform: translateX(-${left}px); }`)
          rule.appendRule('100% { transform: translateX(0); }')
          // $row.style = `${widthStyle}transform: translateX(-${left}px);`
        } else {
          rule.appendRule('0% { transform: translateX(0); }')
          rule.appendRule(`100% { transform: translateX(-${left}px); }`)
        }
        $row.style = `${widthStyle}${animationStyle}`
      })
    },
    getCssRule(name) {
      let cssRule
      let rule
      const ss = document.styleSheets
      for (let i = 0; i < ss.length; ++i) {
        for (let x = 0; x < ss[i].cssRules.length; ++x) {
          rule = ss[i].cssRules[x]
          if (rule.name === name && rule.type === CSSRule.KEYFRAMES_RULE) {
            cssRule = rule
          }
        }
      }
      return cssRule
    },
    async fetchUserInfo() {
      if (!this.common.token) {
        this.userInfoFresh = {}
        return
      }
      try {
        const res = await fetchUserInfo({
          common: this.common,
        })

        if (res && res.resp_common && !res.resp_common.ret) {
          this.userInfoFresh = res.user_info
        }
      } catch (err) {
        // TODO
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ugc-wrap {
  .ctn {
    z-index: 4;
    position: fixed;
    left: 50%;
    top: 50%;
    width: 1170px;
    height: 902px;
    margin: -451px 0 0 -585px;
  }
  .logo {
    position: absolute;
    left: 688px;
    top: 182px;
    width: 170px;
    height: 97px;
    background: url('~@/assets/images/logo.png') 0 0 no-repeat;
  }
  .slogan {
    position: absolute;
    left: 688px;
    top: 315px;
    width: 408px;
    height: 95px;
    background: url('~@/assets/images/ugc-slogan.png') 0 0 no-repeat;
  }
  .link-dynamic {
    position: absolute;
    left: 688px;
    top: 487px;
    width: 200px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    background: #f5b903;
    border-radius: 20px;
    color: #333;
    cursor: pointer;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 28px;
      height: 22px;
      margin-right: 10px;
      background: url('~@/assets/images/icon-video.png') 0 0 no-repeat;
    }
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .link-static {
    position: absolute;
    left: 918px;
    top: 487px;
    width: 200px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    background: #f5b903;
    border-radius: 20px;
    color: #333;
    cursor: pointer;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 26px;
      height: 18px;
      margin-right: 10px;
      background: url('~@/assets/images/icon-pic.png') 0 0 no-repeat;
    }
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .link-contract {
    position: absolute;
    left: 690px;
    top: 580px;
    width: 460px;
    height: 173px;
    background: url('~@/assets/images/btn-contract-bg.png') 0 0 no-repeat;
    strong {
      display: block;
      padding: 38px 0 10px 26px;
      font-size: 24px;
      font-weight: 400;
      color: #E44D91
    }
    span {
      display: block;
      padding-left: 26px;
      font-size: 14px;
    }
    .btn-contract {
      position: absolute;
      left: 26px;
      top: 80px;
      display: inline-block;
      width: 222px;
      height: 91px;
      line-height: 106px;
      text-indent: 22px;
      font-size: 16px;
      color: rgba(255,255,255,1);
      text-shadow: 0px 2px 3px rgba(138,20,40,0.48);
      background: url('~@/assets/images/btn-contract.png') 0 0 no-repeat;
    }
  }
  .sence {
    width: 630px;
    height: 915px;
    background: url('~@/assets/images/sence.png') 0 0 no-repeat;
  }
}
.wallhaven-wrap {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  &::before {
    content: '';
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 50%,rgba(0,0,0,1) 100%);
    opacity: .85;
  }
  &::after {
    content: '';
    z-index: 3;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
  }
  .list {
    z-index: 1;
    position: relative;
  }
  .row {
    display: flex;
    height: 225px;
    margin-bottom: 5px;
    overflow: hidden;
    .item {
      width: 400px;
      margin-right: 5px;
    }
  }
}
</style>
